import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzCilindros } from '@/mocks/localSeoData';

export default function RecuperacaoCilindrosHidraulicosAracruz() {
  return <LocalSeoPage data={aracruzCilindros} />;
}